import React from 'react';
import { motion } from 'framer-motion';

const ToggleSwitch = ({ enabled, onChange, label, description }) => {
  return (
    <div className="flex items-center justify-between p-6 bg-[#1a1a3e] border border-gray-800 rounded-xl hover:border-gray-700 transition-colors">
      <div className="flex-1">
        <h3 className="text-lg font-semibold text-white mb-1">{label}</h3>
        {description && (
          <p className="text-gray-400 text-sm">{description}</p>
        )}
      </div>
      
      <button
        onClick={() => onChange(!enabled)}
        className={`
          relative w-16 h-8 rounded-full transition-colors duration-300 ease-in-out
          ${enabled ? 'bg-gradient-to-r from-green-500 to-green-600' : 'bg-gray-700'}
        `}
      >
        <motion.div
          className="absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-lg"
          animate={{
            x: enabled ? 32 : 0,
          }}
          transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30,
          }}
        />
      </button>
      
      <div className="ml-4 min-w-[60px] text-right">
        <span className={`
          text-sm font-semibold
          ${enabled ? 'text-green-400' : 'text-gray-500'}
        `}>
          {enabled ? 'ON' : 'OFF'}
        </span>
      </div>
    </div>
  );
};

export default ToggleSwitch;
